import { Component, forwardRef, ViewChild, ElementRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS } from '@angular/forms';
import { ItmAbstractControl } from '../itm-abstract-control';

@Component({
	selector: 'itm-checkbox',
	templateUrl: './itm-checkbox.component.html',
	styleUrls: ['./itm-checkbox.component.scss'],
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => ItmCheckboxComponent),
			multi: true
		},
		{
			provide: NG_VALIDATORS,
			useExisting: forwardRef(() => ItmCheckboxComponent),
			multi: true
		}
	],
})
export class ItmCheckboxComponent extends ItmAbstractControl<boolean> {

	@Input() labelBefore = false;
	@Input() cssClassLabel = "ml-2";

	@ViewChild("controlRef") controlRef: ElementRef;
	getControlRef(): ElementRef {
		return this.controlRef;
	}
}
